<template>
  <div style="background-color: lightgray" class="container">
    <div class="header-title">
        <span style="position: absolute;left: 2.2rem;top: 1.5rem;" @click="backUp"><van-icon name="revoke"></van-icon></span>
    提现中心
    </div>
    <div class="sub-continner" style="margin-top: 7.8rem;">
    <div class="main-card">
        <div class="main-card-content" style="font-size: 15px;line-height: 1.6;">
          方法：请填好提现金额和收款地址， 点击提现即可
          <div>提示：
            <span>可提现金额<span style="color: red">{{cashInsidMoney}}</span>元</span>
            <div v-if="cashOutPromptStr != null">{{cashOutPromptStr}}</div>
            <!-- <div>1金={{ustdrmb}}元，<span style="color: #4481eb;font-size: medium">{{cashOutLimitMoney!=null?cashOutLimitMoney:0.00}}</span>金起提， 一天只能申请一次</div> -->
      </div>
        </div>
      </div>
    <van-form @submit="onSubmit">
      <van-row>
        <van-col :span="24">
          <van-field label="取款地址" v-model="cashOutInfo.backCardName" readonly input-align="right"></van-field>
          <van-field label="名称" v-model="cashOutInfo.backCardNum" readonly input-align="right"></van-field>
        </van-col>
      </van-row>
      <van-row style="margin-top: 5%">
        <van-col :span="24">
          <van-field type="number" label="取现金额" v-model="b2cCashOutMoneyManage.cashOutMoney" input-align="right" placeholder="请输入金额"></van-field>
        </van-col>
      </van-row>
      <!--<div style="margin: 2%;text-align: right; font-size: xx-small;color: gray">
        <span>可提现金额<span style="color: red">{{cashInsidMoney}}</span>元</span>
        <div v-if="cashOutPromptStr != null">{{cashOutPromptStr}}</div>
        <div>1金={{ustdrmb}}元，<span style="color: #4481eb;font-size: medium">{{cashOutLimitMoney!=null?cashOutLimitMoney:0.00}}</span>金起提， 一天只能申请一次</div>
      </div>-->
      <div v-show="cashOutInfo.isOpenPayPassword">
        <van-row style="margin-top: 5%">
          <van-col :span="24">
            <van-field label="取现密码" type="password" v-model="b2cCashOutMoneyManage.cashPassword" input-align="right" placeholder="请输入取现密码"></van-field>
          </van-col>
        </van-row>
        <div style="text-align: right; font-size: 12px;margin: 2%">
          <router-link :to="{path:'/home/resetcustomerpwd'}">没有设置或忘记密码</router-link>
        </div>
      </div>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit" :disabled="commitDisable">确认提现</van-button>
      </div>
      <div style="height: 1px;"></div>
    </van-form>
    </div>
    <van-loading size="24px" color="#1989fa" vertical v-show="commitDisable">提现中...</van-loading>
  </div>
</template>

<script>
import {
  commitCashOutMoney,
  getBackCard,
  queryCashOutLimitMoney,
  queryCashOutPromptStr,
  queryUserMoney
} from "../../api/system/sys_backInfo";
import {Dialog} from "vant";
import {isStrEmpty} from "../../lib/utils";
import { mixins } from "../../mixins/mixins";

export default {
  name: "CashOutMoney",
  mixins: [mixins],
  data() {
    return {
      cashOutInfo:{
        backUserName:"zhasa",
        alipayAccount:"18051014066",
      },
      ustdrmb: 7,
      commitDisable:false,
      cashOutLimitMoney:null,
      cashOutPromptStr:null,
      cashInsidMoney:"",
      b2cCashOutMoneyManage:{

      }
    }
  },
  mounted() {
    this.$emit("titleChange", "申请提现");
    getBackCard().then(res=>{
      if (res.success){
        this.cashOutInfo = res.data;
      }
    });
    queryCashOutLimitMoney().then(res=>{
      if (res.success){
        this.cashOutLimitMoney = res.data;
      }
    });
    queryCashOutPromptStr().then(res=>{
      if (res.success){
        this.cashOutPromptStr = res.data;
      }
    });
    queryUserMoney({b2cUsersId:null}).then(res=>{
      console.log(res.data)
      if (res.success){
        this.cashInsidMoney = res.data;
      }
    });
  },
  methods:{
    onSubmit(){
      if (isStrEmpty(this.b2cCashOutMoneyManage.cashOutMoney)){
        this.$notify({message: "请输入取现金额"});
      }else {
        this.b2cCashOutMoneyManage.b2cBackCardId = this.cashOutInfo.id;
        this.commitDisable =true;
        commitCashOutMoney(this.b2cCashOutMoneyManage).then(res => {
          this.$notify({message: "提现审核中，请耐心等待", type: 'success'});
          this.commitDisable = false;
          this.$router.back();
        }).catch(err => {
          this.commitDisable = false;
          this.$notify({message: err.message, type: 'warning'});
          if (err.code == 401) {
            this.$dialog.confirm({message: "您还未设置取现密码，现在要去设置吗?"})
                .then(_ => {
                  this.$router.push({path: '/home/resetcustomerpwd'});
                  //取消新增或修改也要重置表单
                }).catch(err => {
              this.$dialog.close();
            });
          }
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.van-form{
}
</style>
